import { type JSX } from 'react';

import { EloToaster } from '@plurall/elo-v3';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { GlobalRequestLoader } from '@/components';
import { AppLayout } from '@/components/AppLayout';
import { ErrorFallback } from '@/components/ErrorBoundary';

function RootComponent(): JSX.Element {
  return (
    <AppLayout>
      <Outlet />
      <GlobalRequestLoader />
      <EloToaster />
      <TanStackRouterDevtools />
    </AppLayout>
  );
}

function RootErrorComponent({ error, reset }: { error: Error; reset: () => void }): JSX.Element {
  return (
    <AppLayout>
      <ErrorFallback
        error={error}
        errorInfo={null}
        onReset={reset}
        resetButtonText='Tentar novamente'
      />
    </AppLayout>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RootErrorComponent,
});
